// eslint-disable-next-line import/prefer-default-export
export const putBrAfterClosingPTag = input => input.replace(/<br><\/p>/g, '</p><br>');
